import { Routes } from '@angular/router';
import { AuthorizeGuard, SuperAdminGuard, DrivingSchoolAdminGuard } from '@guards/guards';

export const routes: Routes = [
  {
    path: 'user',
    loadComponent: () =>
      import('./components/core/layout/user-layout/user-layout').then(
        (m) => m.StudentLayoutComponent,
      ),

    children: [
      {
        path: '',
        loadChildren: () => import('./components/web/user/user.routes').then((m) => m.routes),
      },
    ],
  },

  {
    path: 'content',
    loadComponent: () =>
      import('./components/core/layout/user-layout/user-layout').then(
        (m) => m.StudentLayoutComponent,
      ),

    children: [
      {
        path: '',
        loadChildren: () => import('./components/web/content/content.routes').then((m) => m.routes),
      },
    ],
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./components/core/layout/admin-layout/admin-layout').then(
        (m) => m.AdminLayoutComponent,
      ),
    canActivate: [AuthorizeGuard, SuperAdminGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./components/web/admin/admin.routes').then((m) => m.routes),
      },
    ],
  },
  {
    path: 'driving-school',
    loadComponent: () =>
      import('./components/core/layout/driving-school-layout/driving-school-layout').then(
        (m) => m.DrivingSchoolLayoutComponent,
      ),
    canActivate: [AuthorizeGuard, DrivingSchoolAdminGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./components/web/driving-school/driving-school.routes').then((m) => m.routes),
      },
    ],
  },

  {
    path: '',
    loadChildren: () => import('./components/web/site/site.routes').then((m) => m.routes),
  },

  {
    path: '**',
    redirectTo: '',
  },
];
